export default "__VITE_ASSET__DQQIV3N___"